const header = document.querySelector('.js-header');

if(header) {
    const scrollHandler = () => {
        if(window.scrollY > header.clientHeight) {
            header.setAttribute('data-scrolled', '');
        } else {
            header.removeAttribute('data-scrolled');
        }
    }

    scrollHandler();
    window.addEventListener('scroll', scrollHandler);
}
